import { CreateCompanyPreferenceMutationVariables } from '../graphql/API';

/**
 * Creates a company preference reset payload for Current Period or Compare Period
 * @param attributeTypeCD - Either "Current Period" or "Compare Period"
 * @returns Mutation variables for resetting the company preference
 */
export const createResetCompanyPreferencePayload = (
  attributeTypeCD: 'Current Period' | 'Compare Period'
): CreateCompanyPreferenceMutationVariables => {
  return {
    createCompanyPreferenceInput: {
      attributetypecd: attributeTypeCD,
      additionalvalue: '',
      attributevalue: 0,
    },
  };
};

/**
 * Resets both Current Period and Compare Period company preferences
 * @returns Array of mutation variables for resetting both preferences
 */
export const createResetBizviewPeriodsPayload = (): CreateCompanyPreferenceMutationVariables[] => {
  return [
    createResetCompanyPreferencePayload('Current Period'),
    createResetCompanyPreferencePayload('Compare Period'),
  ];
};

